// Popup butonları. Liste için ayrı endpoint yoktur; butonlar popup show
// yanıtındaki `buttons` dizisinden okunur. Burada create/put/delete/show var.

const state = () => ({})
const getters = {}

const actions = {
    async show(_, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('module_popup_button') + '/' + id)
        return response.data.data
    },

    async create(_, {data}) {
        const payload = {...data.data, ...data.translate}
        const response = await this._vm.axios.post(this._vm.endpoint.get('module_popup_button'), payload)
        return response.data
    },

    async put(_, {id, data}) {
        const payload = {...data.data, ...data.translate}
        const response = await this._vm.axios.put(this._vm.endpoint.get('module_popup_button') + '/' + id, payload)
        return response.data
    },

    async delete(_, {id}) {
        const {data} = await this._vm.axios.delete(this._vm.endpoint.get('module_popup_button') + '/' + id)
        if (data.status) {
            this._vm.$message.success(this._vm.$t('messages.deleteOk'))
        } else {
            this._vm.$message.error(data.message)
        }
        return data
    },
}

const mutations = {}

export default {namespaced: true, state, getters, actions, mutations}
